// extracted by css-extract-rspack-plugin
export default {"resumeCardContent":"resume-card-content--pA9euQ2yPckXrBh1"};